import "./src/styles/global.css";
import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { injectContentsquareScript } from '@contentsquare/tag-sdk';
import { getLocation } from "./src/util/location";
import { storeAdMetadata } from "./src/util/adMetadata";

// Inject Contentsquare script only in production environment
if (typeof window !== 'undefined' && process.env.APP_ENV === 'prod') {
  injectContentsquareScript({
    siteId: "6392616",
    async: true,
    defer: false
  });
}

// Simple and robust ad metadata capture
export const onInitialClientRender = () => {
  // Only run in production
  if (process.env.APP_ENV !== 'prod') {
    return;
  }

  const queryString = window.location.search;
  if (queryString) {
    storeAdMetadata(queryString);
  }

  // Initialize Hotjar
  initHotjarIdentification();
};

// Hotjar user identification with country info
const initHotjarIdentification = async () => {
  try {
    const waitForHotjar = () => {
      if (typeof window === 'undefined') return;

      if (window.hj) {
        getLocation().then(locationData => {
          if (locationData) {
            window.hj('identify', null, {
              'country': locationData.country || 'Unknown',
            });
          }
        }).catch(err => {
          console.error('Error getting location data for Hotjar:', err);
        });
      } else {
        setTimeout(waitForHotjar, 1000);
      }
    };

    waitForHotjar();
  } catch (error) {
    console.error('Error setting up Hotjar identification:', error);
  }
};

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY}
    >
      {element}
    </GoogleReCaptchaProvider>
  );
};
